import { Flex, Skeleton } from "antd";
import { WhiteBoxBlock } from "ui";
import { TemplatesItem } from "./TemplatesItem";

import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { useEffect } from "react";

import { useNotificationContext } from "providers";
import { requestWithNotify } from "utils";
import { OfferTemplateItem } from "./OfferTemplate/OfferTemplateItem";

export const TemplatesBlock = observer(() => {
  const { templates } = useStores();

  const { openNotification } = useNotificationContext();

  useEffect(() => {
    requestWithNotify({
      fetchFn: () => templates.getTemplates(),
      openNotification: openNotification,
    });
  }, [openNotification, templates]);

  return templates.templatesStatuses.loading ? (
    <WhiteBoxBlock>
      <Flex vertical gap="small">
        <Skeleton active />
        <Skeleton active />
        <Skeleton active />
      </Flex>
    </WhiteBoxBlock>
  ) : (
    <WhiteBoxBlock>
      <Flex vertical gap="large">
        <Flex vertical gap="small">
          <OfferTemplateItem />
          {templates.allTemplates.map((i) => {
            return <TemplatesItem key={i.id} template={i} />;
          })}
        </Flex>
      </Flex>
    </WhiteBoxBlock>
  );
});
